module.exports = __webpack_public_path__ + "static/media/icon-fashion_women.ed8ceab5.png";